import React, { useMemo, useRef } from "react"
import { Link } from "react-router-dom"
import useBreakpoint from "utils/useBreakpoint"
import { Trans } from "react-i18next"
import moment from "moment"
import nl2br from "utils/nl2br"
import isIn from "common/fp/isIn"
import cn from "classnames"
import * as styles from "./index.module.hbd.scss"
import { style } from "react-toastify"
// import Markdown from 'utils/Markdown'
import Markdown from "markdown-to-jsx"
import { createPortal } from "react-dom"
import { Query } from "@apollo/react-components"
import gql from "graphql-tag"
import { Featured } from "./Featured"
import { RandomRead } from "./RandomRead"
import userPlaceHolderImage from "assets/images/user-placeholder.hbd.jpg"
import { PERIOD, usePeriod } from "./usePeriod"
import useInterviewLink from "./useInterviewLink"
import moImage from "assets/images/23hbd/2026/mo.png"
import artypiquesImage from "assets/images/23hbd/2026/artypiques.png"
import lapinStudyingImage from "assets/images/23hbd/2026/lapin-studying.png"
import { Col, Row } from "reactstrap"

const now = moment()

function PortaledH1({ target, children }) {
  return createPortal(children, target)
}

function Home({ currentEdition }) {
  const titleRef = useRef()
  const period = usePeriod(currentEdition)
  const interviewLink = useInterviewLink(currentEdition)
  // const period = PERIOD.AFTER
  const randomReadYear =
    period === PERIOD.DAY_AFTER || period === PERIOD.AFTER ? currentEdition.year : currentEdition.year - 1
  return (
    <div>
      <div className={cn("d-flex flex-column flex-lg-row", styles.mainWrapper)}>
        <div className={styles.mainContent}>
          <h1 ref={titleRef} className="text-secondary" />
          <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start">
            <div>
              <div className={styles.mascotte}>
              </div>
            </div>
            <div className={cn("flex-grow-1 py-3 px-sm-4")}>
              {!!titleRef.current && (
                <div className="d-flex align-items-center">
                  <img src={lapinStudyingImage} alt="" className="d-none d-sm-block mr-4" style={{ width: 160 }} />
                  <div className="flex-grow">
                    <Markdown
                      options={{
                        overrides: {
                          h1: { component: PortaledH1, props: { target: titleRef.current } },
                        },
                      }}
                    >
                      {t(`flavored:home-page.content`)}
                    </Markdown>
                  </div>
                </div>
              )}
              <img src={lapinStudyingImage} alt="" className="d-block d-sm-none mx-auto" />
              {period === PERIOD.BEFORE && (
                <div className={styles.editionDatesInfo}>
                  {t(`flavored:home-page.before-content.dates-info`, {
                    startDay: moment(currentEdition.beginDate).date(),
                    endDay: moment(currentEdition.endDate).date(),
                    year: moment(currentEdition.beginDate).year(),
                  })}
                </div>
              )}
              {period === PERIOD.DAY_BEFORE && (
                <div className={styles.editionDatesInfo}>
                  {t(`flavored:home-page.day-before-content.dates-info`)}
                </div>
              )}
              {period >= PERIOD.DURING && (
                <div className={styles.themeInfo}>
                  {currentEdition.theme ? (
                    <Markdown>{currentEdition.theme}</Markdown>
                  ) : (
                    t(`flavored:home-page.during-content.theme-incoming`)
                  )}
                </div>
              )}
              <TwitchBlock currentEdition={currentEdition} />
            </div>
          </div>
        </div>
        <aside
          className="my-3 text-center border-left-lg-0 px-lg-4 d-flex flex-lg-column align-items-center pb-5 pb-lg-0 justify-content-around justify-content-lg-start"
          style={{ gap: "20px" }}
        >
          <Vip
            src={moImage}
            href="https://www.instagram.com/mo_pasteque/"
            links={[
              interviewLink("illustratorInterview"),
              {
                label: t(`global.download-edition-poster`),
                href: `https://d3npuczmg449ex.cloudfront.net/content/Affiche+23hbd+2026.jpg`,
              },
            ]}
            style={{ maxWidth: 190 }}
          >
            {t(`flavored:home-page.vip-2026.illustrator`)}
          </Vip>
          <Vip
            src={artypiquesImage}
            href="https://artypiques.fr/"
            links={[
              interviewLink("partnerInterview"),
            ]}
            style={{ maxWidth: 190 }}
          >
            {t(`flavored:home-page.vip-2026.partner`)}
          </Vip>
        </aside>
      </div>
      <RandomRead year={randomReadYear} />
    </div>
  )
}

function TwitchBlock({ currentEdition }) {
  const isLg = useBreakpoint("lg")
  if (
    currentEdition &&
    currentEdition.customData &&
    currentEdition.customData.twitch &&
    currentEdition.customData.twitch.active
  ) {
    return isLg ? (
      <div className="mt-5">
        <div
          className="d-flex justify-content-center mt-5"
          dangerouslySetInnerHTML={{ __html: currentEdition.customData.twitch.content }}
        />
      </div>
    ) : (
      <div className="mt-5">
        <Trans i18nKey="flavored:home-page.radio-carotte.simple-link">
          Cette année, suivez les 23hBD avec le stream officiel,{" "}
          <a href={currentEdition.customData.twitch.url}>Radio Carotte</a> !
        </Trans>
      </div>
    )
  }
  return null
}

function Vip({ src, to, href, children, links, placeholder, imgStyle, className, style }) {
  return pug`
    .vip(className=className, style=style)
      AnyLink(to=to)
        .vip-thumbnail
          img(src=(src || userPlaceHolderImage) alt=children style=imgStyle)
      .mt-2
        div
          AnyLink.link-unstyled(to=to href=href)
            span.vip-name= children
        .vip-links
          each link, index in links.filter(Boolean)
            AnyLink(key=index to=link.to href=link.href target=link.target)= link.label
  `
}

function AnyLink(props) {
  let ComponentToUse = "span"
  if (typeof props.href === "string") {
    ComponentToUse = "a"
  }
  if (typeof props.to === "string") {
    ComponentToUse = Link
  }
  return <ComponentToUse {...props} />
}

export default Home
